import { Form } from "react-bootstrap"

import TestToBePerform from "../../../api/LabService/LabServiceModel/TestToBePerform"
import { SampleType } from "../../../api/OrderRequests/OrderRequestsModel/SampleType"

interface SelectSampleTestTypeProps {
  selectedValue?: SampleType
  availableTests: TestToBePerform[]
  disabled?: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

function SelectSampleTestType(props: SelectSampleTestTypeProps) {
  const { selectedValue, availableTests, disabled, onChange } = props

  const disabledSalivaTests = () => availableTests.every((p) => p.SampleTypeCode === SampleType.UR)
  const disabledUrineTests = () => availableTests.every((p) => p.SampleTypeCode === SampleType.SLD)

  return (
    <Form.Group>
      <Form.Check
        inline
        label="URINE TEST"
        id="urine-test-type-radio"
        name="selectedTestType"
        type="radio"
        className="font-weight-bold abc-radio"
        value={SampleType.UR}
        checked={selectedValue === SampleType.UR}
        disabled={disabled || disabledUrineTests()}
        onChange={onChange}
      />
      <Form.Check
        inline
        label="ORAL FLUID TEST"
        id="oral-test-type-radio"
        name="selectedTestType"
        type="radio"
        className="font-weight-bold abc-radio"
        value={SampleType.SLD}
        checked={selectedValue === SampleType.SLD}
        disabled={disabled || disabledSalivaTests()}
        onChange={onChange}
      />
    </Form.Group>
  )
}

SelectSampleTestType.defaultProps = {
  selectedValue: undefined,
  disabled: false,
}

export default SelectSampleTestType
